import Vue from 'vue'
import Axios from './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'

import vuetify from './plugins/vuetify'
import TranslatePlugin from './plugins/translate-plugin'
import Auth from './plugins/auth'
import S3Upload from './plugins/s3-upload'
import Filters from './plugins/filters'
import TablePagination from './plugins/table-pagination'

import translations from './assets/lang'

Vue.config.productionTip = false

Vue.use(TranslatePlugin, {
  translations,
  defaultLang: process.env.DEFAULT_LANG
})

Vue.use(Axios)
Vue.use(Auth)
Vue.use(S3Upload)
Vue.use(Filters)
Vue.use(TablePagination)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
